module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_paperDoubleThick-4f060e1f5d0aed5070432c1d472cb4ac.jpg";